export const computeQuantityOrderLimit = ({ hasPromotionalOffers, promotionalOfferLimit, tradeIn, enable_order_quantity_limit, order_quantity_limit, }) => {
    let quantityLimit = Infinity;
    if (hasPromotionalOffers) {
        quantityLimit = Math.min(promotionalOfferLimit, quantityLimit);
    }
    if (tradeIn) {
        quantityLimit = Math.min(1, quantityLimit);
    }
    if (enable_order_quantity_limit && order_quantity_limit) {
        quantityLimit = Math.min(order_quantity_limit, quantityLimit);
    }
    const hasLimitation = hasPromotionalOffers || tradeIn || (enable_order_quantity_limit && order_quantity_limit);
    return {
        isLimit: hasLimitation ? 1 : 0,
        quantityLimit,
    };
};
//# sourceMappingURL=computeQuantityOrderLimit.js.map